import { render, staticRenderFns } from "./ChatInputBox.vue?vue&type=template&id=793886d8&scoped=true&"
import script from "./ChatInputBox.vue?vue&type=script&lang=js&"
export * from "./ChatInputBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatInputBox.vue?vue&type=style&index=0&id=793886d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793886d8",
  null
  
)

export default component.exports